import React, { useState, useEffect } from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"

import Products from "./Products"
import Transactions from "./Transactions"
import Subscriptions from "./Subscriptions"
import Purchases from "./Purchases"
import Settings from "./Settings"
import Feedback from "./Feedback"

const StoreHome = () => {
  // Custom tab resolver to handle nested routes like /admin/store/subscriptions/feedback
  const tabResolver = (tab, context, pathname) => {
    if (pathname.includes('/subscriptions/feedback')) {
      return 'feedback'
    }
    return tab
  }

  return (
    <SidePanelLayout
      menuName="AdminStoreMenu"
      tabResolver={tabResolver}
      tabs={{
        products: Products,
        subscriptions: Subscriptions,
        purchases: Purchases,
        transactions: Transactions,
        feedback: Feedback,
        settings: Settings,
      }}
    />
  )
}

export default StoreHome
